module.exports = __webpack_public_path__ + "static/media/emptyphoto.b42240b2.svg";